import { render } from "./logoView.vue?vue&type=template&id=019d1eb9&scoped=true"
import script from "./logoView.vue?vue&type=script&lang=js"
export * from "./logoView.vue?vue&type=script&lang=js"

import "./logoView.vue?vue&type=style&index=0&id=019d1eb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019d1eb9"]])

export default __exports__